/**
 * Champions page functionality
 */
import { t } from './i18n';

export function initChampionsPage() {
    const searchInput = document.getElementById('champ-search');
    const countEl = document.getElementById('champ-count');
    const grid = document.getElementById('champ-grid');
    const noResults = document.getElementById('champ-no-results');
    const filterChips = document.querySelectorAll('.class-chip');
    const cards = document.querySelectorAll('.champ-card');
    const adBlocks = document.querySelectorAll('.champ-grid-ad');

    if (!searchInput || !grid) return;

    let activeClass = 'all';

    function filterChampions() {
        const query = searchInput.value.toLowerCase().trim();
        let visibleCount = 0;

        // Hide ads when filtering is active
        const isFiltering = query !== '' || activeClass !== 'all';
        adBlocks.forEach(ad => {
            ad.style.display = isFiltering ? 'none' : '';
        });

        cards.forEach(card => {
            const name = card.dataset.name;
            const tags = card.dataset.tags.split(',');

            const matchesSearch = !query || name.includes(query);
            const matchesClass = activeClass === 'all' || tags.includes(activeClass);

            if (matchesSearch && matchesClass) {
                card.style.display = '';
                visibleCount++;
            } else {
                card.style.display = 'none';
            }
        });

        // Update count
        countEl.textContent = visibleCount + ' ' + getChampionWord(visibleCount);

        // Show/hide no results
        noResults.style.display = visibleCount === 0 ? '' : 'none';
        grid.style.display = visibleCount === 0 ? 'none' : '';
    }

    function getChampionWord(count) {
        const lastTwo = count % 100;
        const lastOne = count % 10;

        if (lastTwo >= 11 && lastTwo <= 19) {
            return t('чемпионов');
        }
        if (lastOne === 1) {
            return t('чемпион');
        }
        if (lastOne >= 2 && lastOne <= 4) {
            return t('чемпиона');
        }
        return t('чемпионов');
    }

    // Search input handler
    searchInput.addEventListener('input', filterChampions);

    // Class filter handlers
    filterChips.forEach(chip => {
        chip.addEventListener('click', function() {
            filterChips.forEach(c => c.classList.remove('active'));
            this.classList.add('active');
            activeClass = this.dataset.class;
            filterChampions();
        });
    });
}

/**
 * Champion detail page - ability tabs
 */
export function initChampionDetailPage() {
    const abilityTabs = document.querySelectorAll('.ability-tab');
    const abilityDetails = document.querySelectorAll('.ability-detail');

    if (!abilityTabs.length) return;

    abilityTabs.forEach(tab => {
        tab.addEventListener('click', function() {
            const index = this.dataset.ability;

            abilityTabs.forEach(t => t.classList.remove('active'));
            abilityDetails.forEach(d => d.classList.remove('active'));

            this.classList.add('active');
            document.querySelector(`.ability-detail[data-ability="${index}"]`)?.classList.add('active');
        });
    });
}

// Auto-init on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initChampionsPage();
    initChampionDetailPage();
});
